export const tooltipStyles = {
  content:
    'z-150 w-fit origin-(--radix-tooltip-content-transform-origin) animate-in rounded-md bg-plum-100 shadow-lg p-4 text-xs text-balance text-denim-500 fade-in-0 zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95',
  arrow: 'z-50 w-4 h-2 fill-plum-100',
} as const;
